import {useMutation, useQueryClient} from '@tanstack/react-query'

import {driverJobKeys} from 'src/driver-view/query-keys'

import {deployEquipment} from './api'
import {equipmentDeploymentKeys} from './query-keys'
import type {DeployEquipmentInput} from './schemas'

export function useDeployEquipment(jobId: string, accessToken: string) {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (input: DeployEquipmentInput) => deployEquipment(jobId, accessToken, input),
        onSuccess: (_data, variables) => {
            void queryClient.invalidateQueries({
                queryKey: equipmentDeploymentKeys.events(variables.rentalAssetId),
            })
            void queryClient.invalidateQueries({
                queryKey: driverJobKeys.detail(jobId, accessToken),
            })
        },
    })
}
